export let devModeOverride = false;
let clickCount = 0;
let lastClickTime = 0;
let lastModeState: boolean | null = null;

export const getDevModeOverride = () => devModeOverride;

export const setDevModeOverride = (value: boolean) => {
  devModeOverride = value;
};

export const checkDevModeClick = () => {
  const now = Date.now();
  if (now - lastClickTime < 500) {
    clickCount++;
    if (clickCount >= 3) {
      devModeOverride = !devModeOverride;
      console.log('[DevMode] 开发者模式已' + (devModeOverride ? '开启' : '关闭'));
      lastModeState = devModeOverride;
      clickCount = 0;
    }
  } else {
    clickCount = 1;
  }
  lastClickTime = now;
  return devModeOverride;
};

// 检查是否刚刚切换了模式，用于外部显示message
export const getAndClearModeChanged = () => {
  if (lastModeState !== null) {
    const changed = lastModeState;
    lastModeState = null;
    return changed;
  }
  return null;
};